<app-fc-select-paged
  class="w-full"
  [service]="fcMaintenanceSelectService"
  [searchProperty]="'number_contains'"
  [control]="control"
  [searchPlaceholder]="'FC_MAINTENANCE_SELECT.SEARCH_PLACEHOLDER' | translate"
  [placeholder]="placeholder || 'FC_MAINTENANCE_SELECT.PLACEHOLDER' | translate"
  [fcTooltip]="fcTooltip"
  [fcTooltipDisabled]="fcTooltipDisabled"
  [fcTooltipPosition]="fcTooltipPosition"
>
</app-fc-select-paged>
